import { render } from "./PointsExchange.vue?vue&type=template&id=513028aa&scoped=true"
import script from "./PointsExchange.vue?vue&type=script&lang=js"
export * from "./PointsExchange.vue?vue&type=script&lang=js"

import "./PointsExchange.vue?vue&type=style&index=0&id=513028aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513028aa"]])

export default __exports__